import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DbResponse} from "../shared/interceptors/db-response";
import {UserService} from "../user/user.service";
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {Router} from "@angular/router";
import {TypeFormAnswers} from "../add-website/typeFormAnswers";
import {UserSubscription, UserSubscriptionCategory} from "../user/user-subscription";
import { filter, first } from 'rxjs';

@Component({
    selector: 'db-workspace-popup-first-time',
    templateUrl: './workspace-popup-first-time.component.html',
    styleUrls: ['./workspace-popup-first-time.component.scss'],
    standalone: false
})

export class WorkspacePopupFirstTimeComponent implements OnInit {

  @Output() closeFirstTimePopup = new EventEmitter<any>();

  @Input() userLocalStorage: any;
  @Input() title: string;
  @Input() desc: string;
  @Input() buttonText1: string;
  @Input() buttonText2?: string;
  @Input() paidClient: boolean;
  @Input() currentSubscription?: UserSubscription;
  @Input() clientRole?: any;
  @Input() invited?: boolean;
  @Input() hasSwitch?: boolean;
  @Input() workspaceSwitchTour?: boolean;
  @Input() activityLogTour?: boolean;
  @Input() hasCloseButton?: boolean;
  @Input() upgraded?: boolean;
  public typeFormAnswers = TypeFormAnswers;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _userService: UserService,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    if (!this.clientRole && this.currentSubscription && this.currentSubscription.category === UserSubscriptionCategory.ENTERPRISE) {
      this.clientRole = 'OrtKduIgRyya';
    }
  }

  public gotIt (closeButtonClicked: boolean = false, clientInvite: boolean = false) {
    if (this.workspaceSwitchTour) {
      this.userLocalStorage['hideWorkspaceSwitchTour'] = true;
      this.closeFirstTimePopup.emit("hideWorkspaceSwitchTour");
    }
    else if (this.activityLogTour) {
      this.userLocalStorage['hideActivityLogTour'] = true;
      this.closeFirstTimePopup.emit("hideActivityLogTour");
    }
    else {
      this.userLocalStorage['hideWorkspaceInviteTour'] = true;
      this.closeFirstTimePopup.emit("hideWorkspaceInviteTour");
    }
    this._userService.setToLocal(this.userLocalStorage)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
        }
      });
    if ( this.hasCloseButton && !closeButtonClicked) {
      if (this.activityLogTour) {
        this._router.navigate(['/activity-log']);
      }
      else if ( this.paidClient ) {
        this._router.navigate(['/user-management'], { queryParams: { 'openInvitationDialog': 1 } });
      }
      else {
        this._router.navigate(['/user-management']);
      }
      this.clientRole && this.createLabelForAnalytics(clientInvite);
    }
  }

  public createLabelForAnalytics(clientInvite: boolean = false): void {
    let label, action;
    if (this.clientRole) {
      switch (this.clientRole) {
        case this.typeFormAnswers.SMB:
        case this.typeFormAnswers.OTHER_BUSINESS:
        case this.typeFormAnswers.E_COMMERCE:
        case this.typeFormAnswers.BLOGGER:
        case this.typeFormAnswers.ENTREPRENEUR:
          action = this.paidClient ? 'Paid User Popup' : 'Trial User Popup';
          label = 'Invitation button click';
          break;
        case this.typeFormAnswers.AGENCY:
          action = this.paidClient ? 'Paid Agency popup' : 'Trial Agency User';
          label = this.paidClient ? clientInvite ? 'Client invitation button click' : 'Team invitation button click' : 'Invitation button click';
          break;
        case this.typeFormAnswers.FREELANCE:
          label = this.paidClient ? 'Client Invitation button click' : 'Invitation button click';
          action = this.paidClient ? 'Paid Freelancer popup' : 'Trial Freelancer popup';
          break;
      }
    }
    else if ( this.currentSubscription && this.currentSubscription.plan && this.currentSubscription.plan.title.toLowerCase().trim() === 'agency' ) {
      action = 'Paid Agency popup';
      label = 'Team invitation button click';
    }
    this.sendToAnalytics(action, label);
  }

  public sendToAnalytics(action, label): void {
    const analyticsData = {
      eventCategory: 'Client Management',
      eventAction: action,
      eventLabel: label
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
